import { css } from '@emotion/core';
import { theme } from '@weave/theme';

export const childStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
});
